<script lang="ts" context="module">
  declare global {
    interface Window {
      TTLStreamReady: any;
      ttlStream: any;
      TTLStream: any;
    }
  }
</script>

<script lang="ts">
  import Dialog, { Header } from '@smui/dialog';
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getStr, isMobile } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import { initialize24TtlStream, isAddToCartDisabled, isPreOrderDisabled } from '../../services/pdp-data-services';
  import {
    currentSelectedStoreData,
    flixMediaDataAvailabilityChecked,
    flixMediaDataAvailable,
    isTTL24DataAvailable,
    pdpMoreInfoActiveTab,
    pdpTitleData,
    productDetailMainData,
    productPriceData,
    showPdpMoreInfoModal,
  } from '../../store/pdp_store';
  import ExtraProductTitle from '../ExtraProductTitle.svelte';
  import PdpMoreInfoContent from '../PdpMoreInfoContent.svelte';
  import PdpMoreInfoTabs from '../PdpMoreInfoTabs.svelte';
  import PdpQuantityModifier from '../PdpQuantityModifier.svelte';
  import PdpButton from './../PdpButton.svelte';
  import ProductPrice from './../ProductPrice.svelte';
  import ReviewImageGallery from '../ReviewImageGallery.svelte';

  const { distributorId, flixmediaLanguage, modelNumber, flixInpage, flixButtonImage, fallbackLanguage, flixPrice } =
    getAppConfig();
  export let data: any;
  $: cfsInStock =
    $currentSelectedStoreData?.stockLevelStatus?.code === 'inStock' ||
    $currentSelectedStoreData?.stockLevelStatus?.code === 'lowStock';
  let FlixStyle = 'flex';
  let videoPlayer;
  let mutationObserverInstance;
  let isStickyHeader = false;

  let scrollComponent;
  let tabsStickyTrigger;
  let stickyHeaderObserver;

  $: if (
    $pdpMoreInfoActiveTab == 'Discover' &&
    data?.highlights == null &&
    !(data?.highlightsProvider == 'FLIX' && $flixMediaDataAvailable == true) &&
    !(data?.highlightsProvider == 'TTL_24' && $isTTL24DataAvailable == true) &&
    !($productDetailMainData.isMarketPlaceProduct == true && data?.description != null)
  ) {
    $pdpMoreInfoActiveTab = 'GeekyInfo';
  }
  $: if ($flixMediaDataAvailable && $flixMediaDataAvailabilityChecked) {
    queueMicrotask(installMutationObserverForFlixMediaDOM);
  }

  $: if ($pdpMoreInfoActiveTab == 'GeekyInfo' && data?.productSpecifications == null && data?.classifications == null) {
    $pdpMoreInfoActiveTab = 'Reviews';
  }
  function closeHandler(_e: CustomEvent<{ action: string }>) {
    $showPdpMoreInfoModal = false;
  }

  const dispatcher = createEventDispatcher();

  function addToCart() {
    dispatcher('addToCart', null);
  }
  function openWriteReview() {
    $showPdpMoreInfoModal = false;
    dispatcher('openWriteReview');
  }
  let isDataLoaded = false;

  onMount(async () => {
    var discoverSection = document.querySelector('.discover-section');
    var iframe = discoverSection?.querySelector('iframe');

    if (iframe) {
      iframe.setAttribute('scrolling', 'no');
    }
    setupStickyHeaderObserver();
    //optimized
    if (data?.highlightsProvider === 'TTL_24') {
      initialize24TtlStream(data, modelNumber);
    }
    videoPlayer = document.getElementsByTagName('video');
    return () => {
      if (mutationObserverInstance) {
        mutationObserverInstance.disconnect();
      }
    };
  });

  onDestroy(() => {
    observer.disconnect();
    stickyHeaderObserver?.disconnect();
  });
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.querySelector('.mdc-dialog__header').scrollIntoView(true);
        observer.disconnect();
      }
    });
  });

  function installMutationObserverForFlixMediaDOM() {
    const targetNode = document.getElementById('flix-inpage');
    const config = { childList: true, subtree: true };
    console.log('[FLIX] Installing mutation observer');
    mutationObserverInstance = new MutationObserver(onMutationObserved);
    mutationObserverInstance.observe(targetNode, config);
  }
  function onMutationObserved(mutationList: MutationRecord[]) {
    console.log('[FLIX] Mutation observed');

    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        console.log('[FLIX] Mutation observed added nodes: ', mutation.addedNodes);
        const hasAnyNonScriptElement = Array.from(mutation.addedNodes).some(node => node.nodeName !== 'SCRIPT');
        if (hasAnyNonScriptElement) {
          FlixStyle = 'none';
          isDataLoaded = true;
          mutationObserverInstance?.disconnect();
          observer.observe(scrollComponent);
        } else {
          console.log('[FLIX] added only script currently');
          document.querySelector('.mdc-dialog__header').scrollIntoView(true);
        }
      }
    }
  }

  function closePopup() {
    showPdpMoreInfoModal.set(false);
    isStickyHeader = false;
    if (videoPlayer) {
      for (let i = 0; i < videoPlayer.length; i++) {
        videoPlayer[i].pause();
      }
    }
  }

  /**
   * Sets up an IntersectionObserver to track when the sticky header should be activated.
   *
   * The observer monitors the visibility of the tabs sticky trigger element within the dialog content.
   * When the trigger element moves above the dialog's top boundary and is no longer intersecting,
   * the sticky header becomes active.
   *
   * Only initializes the observer on mobile devices. Disconnects any existing observer before setup.
   *
   * @async
   * @function setupStickyHeaderObserver
   * @returns {Promise<void>}
   */
  async function setupStickyHeaderObserver() {
    stickyHeaderObserver?.disconnect();
    if (!tabsStickyTrigger || !isMobile()) {
      isStickyHeader = false;
      return;
    }
    const dialogContent = document.querySelector('.pdp-details-story-dialog .mdc-dialog__content');
    stickyHeaderObserver = new IntersectionObserver(
      ([entry]) => {
        isStickyHeader = entry.boundingClientRect.top <= entry.rootBounds?.top && !entry.isIntersecting;
      },
      {
        root: dialogContent,
        threshold: 0,
      }
    );
    stickyHeaderObserver.observe(tabsStickyTrigger);
  }

  $: disabledAddToCartBtn = isAddToCartDisabled(data, cfsInStock);
  $: disabledPreOrderBtn = isPreOrderDisabled(data);
  $: if ($showPdpMoreInfoModal) {
    setupStickyHeaderObserver();
  } else {
    isStickyHeader = false;
  }
</script>

<Dialog
  class="pdp-details-story-dialog"
  bind:open={$showPdpMoreInfoModal}
  fullscreen
  aria-labelledby="fullscreen-title"
  aria-describedby="fullscreen-content"
  on:SMUIDialog:closed={closeHandler}
>
  <Header>
    <div class="d-flex product-image-and-title-productinfo">
      <div class="product-image-and-title-img">
        {#if isMobile()}
          <img src="{data?.amplienceProductBaseUrl}&w=200&h=200" alt={data?.name} />
        {:else}
          <img src="{data?.amplienceProductBaseUrl}&w=200&h=200" alt={data?.name} />
        {/if}
      </div>
      <ExtraProductTitle data={$pdpTitleData} />
    </div>
    {#if !((data?.isComingSoon && data?.isDigitalGiftCard != true) || (data?.stock.stockLevelStatus.code == 'outOfStock' && data?.isDigitalGiftCard != true))}
      <div class="ProductPrice-container">
        <ProductPrice showDiscountUp={false} data={$productPriceData} />
      </div>

      {#if data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock'}
        <div class="d-flex add-to-cart-container" class:qty-modifier-section={!data?.isDigitalGiftCard}>
          {#if data?.isAddToCartEnabled}
            <PdpQuantityModifier
              containerClass="sticky-bar"
              displayQtyModifier={data?.productStatus === 'PRE_ORDER' ? !disabledPreOrderBtn : !disabledAddToCartBtn}
            />
            {#if (data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock') && data?.productStatus === 'PRE_ORDER'}
              <div class="d-flex cart-action-buttons">
                <PdpButton
                  label={getStr('extra.preorderbutton')}
                  type="secondary"
                  size="large"
                  productCode={data?.productCode}
                  variant="solid"
                  disabled={disabledAddToCartBtn}
                  on:click={() => addToCart()}
                />
              </div>
            {:else if data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock'}
              <div class="d-flex cart-action-buttons">
                <PdpButton
                  label={getStr('extra.addtocartbutton')}
                  type="secondary"
                  size="large"
                  productCode={data?.productCode}
                  variant="solid"
                  disabled={disabledAddToCartBtn}
                  on:click={() => addToCart()}
                />
              </div>
            {/if}
          {/if}
        </div>
      {/if}
    {/if}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="close-popup-container" on:click={() => closePopup()}>
      <Icon type="font" glyph="close" mobileSize={20} desktopSize={20} />
    </div>
  </Header>
  {#if isStickyHeader}
    <div class="sticky-header-mobile">
      <div class="sticky-header-product">
        <img src="{data?.amplienceProductBaseUrl}&w=80&h=80" alt={data?.name} class="sticky-header-img" />
        <div class="sticky-header-info">
          <div class="sticky-header-brand">{data?.brandNameEn}</div>
          <div class="sticky-header-title">{data?.name}</div>
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="sticky-header-close" on:click={() => closePopup()}>
          <Icon type="font" glyph="close" mobileSize={24} desktopSize={20} />
        </div>
      </div>
      <div class="sticky-header-tabs">
        <PdpMoreInfoTabs {data} />
      </div>
    </div>
  {/if}
  <div bind:this={scrollComponent}></div>
  <div bind:this={tabsStickyTrigger} class="tabs-default-mobile">
    <PdpMoreInfoTabs {data} />
  </div>
  <PdpMoreInfoContent
    {data}
    {isDataLoaded}
    {FlixStyle}
    {distributorId}
    {flixmediaLanguage}
    {modelNumber}
    {flixInpage}
    {flixButtonImage}
    {fallbackLanguage}
    {flixPrice}
    enableRichMedia={true}
    onOpenWriteReview={openWriteReview}
  />
</Dialog>

<ReviewImageGallery />

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  * :global {
    .product-specification-container-onpopup .product-key-specifications-container .title {
      display: none;
    }
  }

  :global {
    .pdp-details-story-dialog .mdc-dialog__surface {
      // width: calc(100vw - 20px) !important;
      width: 100vw !important;
      min-height: 100%;
      max-height: 100% !important;
      background-color: $primary-white !important;
      @include desktop-min-width {
        // width: calc(100vw - 20px) !important;
      }
    }
    .pdp-details-story-dialog .finance-options-row {
      display: none;
    }
    .pdp-details-story-dialog .offers-row {
      display: none;
    }
    .pdp-details-story-dialog .mdc-tab .mdc-tab__ripple {
      display: none;
    }
    .pdp-details-story-dialog .mdc-dialog__header {
      justify-content: center;
      flex-wrap: wrap;
      margin: 0;
      padding: 16px;
      .product-image-and-title-productinfo {
        align-items: center;
        padding-top: 16px;
        @include desktop-min-width {
          padding-top: 0px;
        }
        .product-image-and-title-img {
          padding: 0;
          width: 48px;
          align-items: center;
          margin-right: 12px;
          object-fit: cover;
          flex-shrink: 0;
          @include desktop-min-width {
            width: 80px;
            margin-right: 16px;
          }
        }
        @include desktop-min-width {
          flex-basis: 33%;
        }
      }
      .product_price {
        flex-direction: column;
        padding: 0 0 0 55px;
        width: 100%;
        @include desktop-min-width {
          flex-direction: row;
        }
      }
      .product_title {
        background-color: $primary-white;
        padding: 0;
        margin-right: 36px;
      }
      @include desktop-min-width {
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        padding: 16px 48px !important;
        .product_price {
          padding: 0;
          padding-left: 24px;
          .product_price__left,
          .product_price__right {
            .price-row {
              .amount-info {
                font-size: 24px;
                line-height: 26px;
              }
              .tasheel-info {
                max-width: 60px;
                max-height: 20px;
              }
            }
            .discount-row {
              .old-price,
              .price-savings {
                font-size: 14px;
                line-height: 16px;
              }
            }
            .finance-row {
              .finance-text {
                font-size: 14px;
                line-height: 16px;
              }
            }
          }
        }
      }
    }
    .mdc-dialog__container {
      .mdc-tab {
        min-width: auto;
        flex: inherit;
        .mdc-tab__text-label {
          background-color: $primary-white;
          border: none;
          color: $primary-black;
          font-weight: 400;
          font-size: 16px;
          line-height: 18px;
        }
      }
    }
    .mdc-dialog__container {
      .mdc-tab {
        &.mdc-tab--active {
          .mdc-tab__text-label {
            color: $primary-blue;
            font-weight: 700;
          }
        }
      }
    }

    .pdp-details-story-dialog {
      z-index: 9999 !important;
    }
    .mdc-dialog__content {
      @include desktop-min-width {
        overflow: initial;
      }
    }
    .mdc-tab-scroller__scroll-content {
      border-bottom: 1px solid $color-grey-border;
      display: flex;
      flex: inherit !important;
      will-change: auto !important;
      justify-content: flex-start;
      width: 100%;
      overflow: auto;
      position: relative;
      @include desktop-min-width {
        justify-content: center;
      }
      .mdc-tab__text-label {
        white-space: nowrap;
      }
    }
    .mdc-tab {
      background-color: $primary-white;
      border: none;
      color: $primary-black;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      margin: 16px 48px 0px 0;
      padding-bottom: 17px;
      &.mdc-tab--active {
        color: $primary-blue;
        font-weight: 700;
        border-bottom: 2px solid $primary-blue;
      }
    }
    .solo-paper {
      width: 100%;
      height: 48px;
      background-color: $primary-white;
      border: 1px solid $secondary-gray-01;
      border-radius: 8px;
      box-shadow: none !important;
      input {
        color: $neutral-dark-02;
        font-weight: 400;
        font-size: 16px;
        line-height: 18px;
      }
      input::placeholder {
        color: $secondary-gray-01;
        font-weight: 400;
        font-size: 16px;
        line-height: 18px;
      }
      @include desktop-min-width {
        width: 522px;
      }
    }
    .mdc-button--raised {
      box-shadow: none !important;
      &.mdc-ripple-upgraded {
        margin-right: 0;
        padding: 5px 12px !important;
        @include desktop-min-width {
          padding: 10px 24.5px !important;
        }
      }
      &.mdc-ripple-upgraded--background-focused,
      .mdc-button--raised:not(.mdc-ripple-upgraded):focus {
        box-shadow: none !important;
      }
    }

    .mdc-button__label {
      white-space: nowrap;
      font-size: 12px;
      line-height: 14px;
      @include desktop-min-width {
        font-size: 14px;
        line-height: 16px;
      }
    }
    .pdp-details-story-dialog .mdc-ripple-upgraded::before {
      background-color: $primary-white !important;
    }
    .pdp-details-story-dialog .mdc-ripple-upgraded::after {
      background-color: $primary-white !important;
    }
    .pdp-details-story-dialog .mdc-ripple-upgraded::hover {
      background-color: $primary-white !important;
    }
    .product-specification-container-onpopup {
      .product-key-specifications-container .card-display .card-container {
        height: 193px;
        width: 160px;
        @include desktop-min-width {
          height: 260px;
          width: 260px;
        }
      }
      .product-key-specifications-container {
        margin-top: 0 !important;
      }
    }
    .pdp-details-story-dialog {
      ul.specs-tabs-list {
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      ul.specs-tabs-list {
        list-style: none !important;
        display: flex !important;
        justify-content: flex-start !important;
        border-bottom: 1px solid $secondary-gray-02 !important;
        margin: 0;
        padding: 0 16px;
        overflow: scroll;
        align-items: center;
        li {
          cursor: pointer;
          padding: 16px 0px;
          white-space: nowrap;
          font-weight: 400;
          font-size: 14px;
          line-height: 10px;
          color: $primary-black;
          @include desktop-min-width {
            font-size: 16px;
            line-height: 18px;
            padding: 16px 24px;
          }
          &.active {
            border-bottom: 2px solid $primary-blue;
            color: $primary-blue;
            font-weight: 700;
          }
        }
      }
      .product-key-specifications-container .card-display {
        overflow-x: scroll !important;
        @include desktop-min-width {
          overflow-x: auto !important;
        }
      }
      .cart-action-buttons {
        .button-div:first-child {
          margin-right: 16px;
        }
        .button-div button {
          min-height: auto !important;
          font-size: 14px !important;
          line-height: 16px !important;
        }
      }
    }
  }

  @include desktop-max-width {
    :global {
      .pdp-details-story-dialog {
        .ProductPrice-container {
          width: 100% !important;
        }
        .product_price__left {
          width: 85% !important;
          padding-left: 8px;
          border-bottom: 1px solid $secondary-gray-02;
        }
        .product_price__right {
          width: 100% !important;
          padding-left: 8px;
        }
      }
    }
  }

  :global {
    .pdp-details-story-dialog {
      .mdc-dialog__container {
        .mdc-dialog__header {
          .product_title {
            .product-name {
              font-size: 14px;
              line-height: 16px;
              font-weight: 500;
              margin-top: 2px;
            }
          }
        }
      }
    }
  }
  .close-popup-container {
    display: block;
    position: absolute;
    right: 18px;
    top: 34px;
    cursor: pointer;
    color: $icon-only-icon-blue;
    @include desktop-min-width {
      top: 15px;
      right: 15px;
    }
  }

  .add-to-cart-container {
    justify-content: flex-end;
    align-items: center;
    padding: 0 0 0 55px;
    margin: 15px 0 0 0;
    width: 100%;
    &.qty-modifier-section {
      justify-content: space-between;
      padding: 0 0 0 64px;
      @include desktop-min-width {
        padding: 0 0 0 24px;
      }
    }
    @include desktop-min-width {
      justify-content: flex-end;
      padding: 0;
      margin: 0;
      width: auto;
      flex-basis: 25%;
      &.qty-modifier-section {
        justify-content: flex-end;
        padding: 0;
      }
    }
    .add-to-wish-list {
      width: 50%;
      flex-basis: 50%;
      display: block;
      @include desktop-min-width {
        display: none;
      }
    }
  }
  .product-specification-container-onpopup {
    background: $neutral-light-04;
    padding: 16px 24px;
    @include desktop-min-width {
      padding: 60px 48px;
    }
    .specifivcation-title-text {
      color: $neutral-dark-01;
      font-weight: 700;
      font-size: 20px;
      line-height: 22px;
      padding-bottom: 2px;
      @include desktop-min-width {
        color: $neutral-dark-02;
        font-size: 48px;
        line-height: 52px;
        padding-bottom: 24px;
      }
    }
    .specifivcation-sub-title-text {
      color: $neutral-dark-02;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      padding-bottom: 16px;
      @include desktop-min-width {
        font-size: 18px;
        line-height: 20px;
        padding-bottom: 50px;
      }
    }
  }

  * :global(.solo-paper) {
    display: flex;
    align-items: center;
    flex-grow: 1;
    max-width: 600px;
    // margin: 0 12px;
    padding: 0 12px;
    height: 48px;
  }
  * :global(.solo-paper > *) {
    display: flex;
    justify-content: space-between;
    margin: 0 12px;
  }
  * :global(.solo-input) {
    flex-grow: 1;
    color: var(--mdc-theme-on-surface, #000);
  }
  * :global(.solo-input::placeholder) {
    color: var(--mdc-theme-on-surface, #000);
    opacity: 0.6;
  }

  .product-tabs-container {
    display: none;
    .tab-options {
      display: grid;
    }
  }

  .tab-options-container {
    display: flex;
    overflow-x: auto;
    .product-tab {
      cursor: pointer;
      color: $color-bg-black;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      background: $primary-white;
      border: 1px solid $secondary-gray-02;
      border-radius: 8px;
      padding: 10px 20px;
      margin-right: 8px;
      min-width: auto;
      overflow: initial;
      &.selected {
        color: $color-bg-black;
        border: 1px solid $icon-only-icon-blue;
        font-weight: 700;
      }
    }
  }

  .tab-options-container {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ProductPrice-container {
    @include desktop-min-width {
      flex-basis: 40%;
    }
  }

  .sticky-header-mobile {
    display: none;
  }

  .tabs-default-mobile {
    width: 100%;
  }

  @include desktop-max-width {
    .sticky-header-mobile {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 20;
      background: $primary-white;
      box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
    }

    .sticky-header-product {
      display: grid;
      grid-template-columns: 48px minmax(0, 1fr) 24px;
      align-items: start;
      gap: 12px;
      padding: 16px 16px 27px;
      background: #f3f8fd;
    }

    .sticky-header-img {
      width: 48px;
      height: 48px;
      object-fit: contain;
      align-self: center;
    }

    .sticky-header-info {
      min-width: 0;
      padding-top: 2px;
    }

    .sticky-header-brand {
      color: $primary-blue;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
      margin-bottom: 2px;
    }

    .sticky-header-title {
      color: $neutral-dark-01;
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
    }

    .sticky-header-close {
      border-radius: 50%;
      color: $primary-blue;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
    }

    .sticky-header-tabs {
      background: $primary-white;
      overflow-x: auto;
      scrollbar-width: none;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
    }

    .sticky-header-tabs::-webkit-scrollbar {
      display: none;
    }
  }

  .flix_loaderContainer {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.2);
    cursor: not-allowed;
  }
  .flix_loader {
    background: url(../../images/extra-loader.gif) no-repeat;
    height: 20rem;
    width: 20rem;
  }
  .p_0 {
    padding: 0 !important;
  }
</style>
